import { memo } from 'react'

import { PairLiquidityFormatted } from '@root/entities/pair/ui/common/pair-liquidity-formatted'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { useTranslation } from '@root/shared/localization'

import { TradingPairExploreItemMetricsItem } from './pair-explore-item-metrics-item'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const TradingPairExploreItemMetricsLiquidity = memo(
  ({ pair, className }: Props) => {
    const { t } = useTranslation()

    return (
      <TradingPairExploreItemMetricsItem className={className}>
        <TradingPairExploreItemMetricsItem.Label>
          {t('pool.liquidity-char').toUpperCase()}
        </TradingPairExploreItemMetricsItem.Label>
        <FlashTextContentDistinct>
          <PairLiquidityFormatted pair={pair} />
        </FlashTextContentDistinct>
      </TradingPairExploreItemMetricsItem>
    )
  },
)
